import * as React from 'react';

function SvgReferFriends(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="refer_friends_svg__clip-path">
          <path
            id="refer_friends_svg__Rectangle_411"
            d="M0 0h24v24H0z"
            data-name="Rectangle 411"
            transform="translate(116 758)"
            fill="#fff"
            stroke="#707070"
          />
        </clipPath>
        <style>{'.refer_friends_svg__cls-3{fill:#e92c81}'}</style>
      </defs>
      <g
        id="refer_friends_svg__refer_friends"
        transform="translate(-116 -758)"
        clipPath="url(#refer_friends_svg__clip-path)"
      >
        <g
          id="refer_friends_svg__Group_385"
          data-name="Group 385"
          transform="translate(-1995.357 -1948.385)"
        >
          <ellipse
            id="refer_friends_svg__Ellipse_46"
            cx={2.629}
            cy={2.436}
            className="refer_friends_svg__cls-3"
            data-name="Ellipse 46"
            rx={2.629}
            ry={2.436}
            transform="translate(2113.623 2715.398)"
          />
          <ellipse
            id="refer_friends_svg__Ellipse_47"
            cx={2.629}
            cy={2.436}
            className="refer_friends_svg__cls-3"
            data-name="Ellipse 47"
            rx={2.629}
            ry={2.436}
            transform="translate(2126.841 2708.162)"
          />
          <ellipse
            id="refer_friends_svg__Ellipse_48"
            cx={2.629}
            cy={2.436}
            className="refer_friends_svg__cls-3"
            data-name="Ellipse 48"
            rx={2.629}
            ry={2.436}
            transform="translate(2127.083 2722.538)"
          />
          <g
            id="refer_friends_svg__Group_384"
            data-name="Group 384"
            transform="translate(2111.934 2706.385)"
          >
            <path
              id="refer_friends_svg__Path_728"
              d="M2129.566 2721.06a4.114 4.114 0 00-3.047 1.348l-6.564-3.158a4.083 4.083 0 000-2.791l6.564-3.157a4.216 4.216 0 10-1.03-2.143l-6.988 3.36a4.133 4.133 0 100 6.669l6.988 3.361a4.176 4.176 0 00-.055.642 4.133 4.133 0 104.134-4.131zm0-12.234a1.693 1.693 0 11-1.247 2.83l-.342-.373-.079-.5a1.79 1.79 0 01-.025-.262 1.694 1.694 0 011.693-1.695zm-11.909 9.6l-.173.483-.426.312a1.673 1.673 0 01-.992.327 1.692 1.692 0 110-3.385 1.678 1.678 0 01.995.328l.423.309.172.482a1.705 1.705 0 01.1.573 1.656 1.656 0 01-.099.571zm11.908 8.458a1.7 1.7 0 01-1.693-1.693 1.858 1.858 0 01.026-.266l.077-.494.344-.377a1.67 1.67 0 011.246-.554 1.692 1.692 0 110 3.384z"
              data-name="Path 728"
              transform="translate(-2111.934 -2706.385)"
              fill="#235dd4"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgReferFriends;
